import PuzzleService from '_services/rest/modules/puzzle-term';
import { handleResourceLoadError } from '_utils';

export default {
  state: {
    puzzle: null,
    puzzleList: null,
  },
  mutations: {
    setPuzzleTermList(state, response) {
      state.puzzleList = response;
    },
    setPuzzleTerm(state, puzzle) {
      state.puzzle = puzzle;
    },
  },
  actions: {
    getPuzzleTerm({ commit, dispatch }, id) {
      return PuzzleService.getPuzzleById(id)
        .then(response => {
          commit('setPuzzleTerm', response);
        })
        .catch(error => {
          handleResourceLoadError(dispatch, error, 'admin-puzzle-term-list');
        });
    },
    getPuzzleTermList({ commit }, params) {
      PuzzleService.getPuzzles(params)
        .then(response => {
          commit('setPuzzleTermList', response);
        });
    },
  },
};
